module.exports = __webpack_public_path__ + "img/ruanzhu07.fd45234e.png";